<template>
  <div ref="slimScrollDiv" :style="{height: height + 'px'}">
    <slot />
  </div>
</template>

<script>
export default {
  name: "SlimScroll",
  props: {
    height: {
      type: [Number, String],
      default: '600'
    }
  },
  mounted() {
    $(this.$refs.slimScrollDiv).slimscroll({
      alwaysVisible: false,
      height: this.$props.height
    })
  },
  beforeDestroy() {
  }
}
</script>
